/* ==========================================================================
   WELIA BUTIK (kopie van CMFY) — storefront behaviour, Poolse teksten
   No framework, no dependencies. Everything degrades to a working page
   if JavaScript fails.
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = window.CL_MONEY_FORMAT || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','));
  };

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------ drawers -- */

  var lastFocus = null;

  /* Foto's in de winkelwagenlade vooraf laden (gebruiker 11-10: 'winkelwagen laadt niet mooi als je erop klikt').
     De lade staat verborgen (display: none), dus loading="lazy" haalde de foto's pas op na het openen: eerst een
     leeg vak, daarna sprong de foto erin. Nu laden ze op de achtergrond zodra de pagina klaar is, en meteen bij
     het aanraken van het tasje. Is een foto bij het openen toch nog onderweg, dan komt hij zacht in beeld. */
  function warmDrawer(d) {
    d = d || $('[data-cl-drawer="cart"]');
    if (!d) return;
    $$('img', d).forEach(function (im) { if (im.loading === 'lazy') im.loading = 'eager'; });
  }
  function waitFade(im) {
    if (im.complete || im.hasAttribute('data-wb-wait')) return;
    im.setAttribute('data-wb-wait', '');
    var done = function () { im.removeAttribute('data-wb-wait'); };
    im.addEventListener('load', done, { once: true });
    im.addEventListener('error', done, { once: true });
    window.setTimeout(done, 4000);
  }

  function openDrawer(name) {
    var d = $('[data-cl-drawer="' + name + '"]');
    if (!d) return;
    lastFocus = document.activeElement;
    if (name === 'cart') { warmDrawer(d); $$('img', d).forEach(waitFade); }
    d.setAttribute('data-cl-opening', '1');
    d.hidden = false;
    // scrollbalk op de computer verdwijnt; ruimte vasthouden zodat de pagina erachter niet opzij springt
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    // rAF gives the browser a frame to paint the closed state first so the
    // slide-in animates. It does not fire in a hidden tab, so a timeout
    // guarantees the drawer still opens.
    var opened = false;
    var reveal = function () { if (!opened) { opened = true; d.classList.add('is-open'); } };
    requestAnimationFrame(reveal);
    window.setTimeout(reveal, 60);
    // focus zonder te scrollen: het paneel staat nog buiten beeld en mag niet meteen naar binnen springen
    var focusable = d.querySelector('button, a, input');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function closeDrawer(d) {
    if (!d) d = $('.cl-drawer.is-open');
    if (!d) return;
    d.removeAttribute('data-cl-opening');
    d.classList.remove('is-loading');
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    window.setTimeout(function () { d.hidden = true; }, 320);
    if (lastFocus) { lastFocus.focus({ preventScroll: true }); lastFocus = null; }
  }

  (function () {
    var go = function () { warmDrawer(); };
    var later = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 2500 });
      else window.setTimeout(go, 1200);
    };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    ['pointerover', 'touchstart', 'focusin'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target.closest && e.target.closest('[data-cl-open="cart"]')) warmDrawer();
      }, { passive: true });
    });
  })();

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cl-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-cl-open')); return; }
    if (e.target.closest('[data-cl-close]')) { e.preventDefault(); closeDrawer(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* --------------------------------------------------------------- cart -- */

  /* Nieuwe inhoud van de lade plaatsen. De HTML komt mee in het antwoord van cart/add.js of
     cart/change.js (sections), of los via ?sections=. Een lade die open is of net opengaat blijft open. */
  function swapDrawer(html) {
    if (!html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-cl-drawer="cart"]');
    var current = $('[data-cl-drawer="cart"]');
    if (!fresh || !current) return false;
    var wasOpen = current.classList.contains('is-open') || current.hasAttribute('data-cl-opening');
    fresh.hidden = current.hidden;
    if (wasOpen) { fresh.classList.add('is-open'); fresh.setAttribute('data-cl-opening', '1'); }
    /* Netjes verversen (gebruiker 11-10: 'overgang van productpagina naar winkelwagen heel netjes'): foto's meteen
       laden en tekenen (geen witte flits), de schuifpositie blijft staan en de lade schuift niet opnieuw in. */
    $$('img', fresh).forEach(function (im) { im.loading = 'eager'; im.decoding = 'sync'; });
    // een productfoto die al in beeld stond, houdt exact hetzelfde bestand (anders kiest srcset soms een andere maat en knippert hij)
    $$('.wb-line[data-variant]', fresh).forEach(function (line) {
      var was = current && current.querySelector('.wb-line[data-variant="' + line.getAttribute('data-variant') + '"] img');
      var now = line.querySelector('img');
      if (was && now && was.complete && was.naturalWidth) {
        now.removeAttribute('srcset'); now.removeAttribute('sizes'); now.src = was.currentSrc || was.src;
      }
    });
    var oldScroll = current.querySelector('.wb-cart__scroll');
    var keepTop = oldScroll && !oldScroll.classList.contains('wb-cart__scroll--pending') ? oldScroll.scrollTop : 0;
    parkExpress(current);
    current.parentNode.replaceChild(fresh, current);
    var newScroll = fresh.querySelector('.wb-cart__scroll');
    if (newScroll && keepTop) newScroll.scrollTop = keepTop;
    // verzendregel meteen invullen (anders staat hij tot de volgende seconde verborgen en springt de lade)
    if (typeof dispatchTick === 'function') dispatchTick();
    clonePayMarks();
    placeExpress();
    if (wasOpen) { var close = fresh.querySelector('[data-cl-close]'); if (close) close.focus({ preventScroll: true }); }
    return true;
  }

  /* Diensten (producttype 'Usługa', bijv. extra beveiligd verzenden) tellen niet mee als product. */
  var isSvc = function (it) { return !!it && it.product_type === 'Usługa'; };
  var goodsCount = function (cart) {
    if (!cart || !cart.items) return cart && cart.item_count || 0;
    return cart.items.reduce(function (n, it) { return n + (isSvc(it) ? 0 : it.quantity); }, 0);
  };

  function setCount(n, raw) {
    var count = $('[data-cl-cart-count]');
    if (!count) return;
    var before = count.hidden ? 0 : Number(count.textContent) || 0;
    count.textContent = n; count.hidden = n === 0; if (raw != null) count.setAttribute('data-cl-cart-raw', raw);
    // het getal bij het tasje tikt even aan als er iets bij komt (gebruiker 19-10)
    if (n > before) { count.classList.remove('is-bump'); void count.offsetWidth; count.classList.add('is-bump'); }
  }

  /* Aantal in de kop bijwerken en de jubileumcadeaus rechtzetten (loopt na het tonen, houdt niets op). */
  function syncCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        setCount(goodsCount(cart), cart.item_count);
        return aeTidy(cart).then(function (changed) {
          if (!changed) return;
          if (onCartPage()) { window.location.reload(); return; }
          return refreshCart(false);
        });
      });
  }

  function refreshCart(open) {
    return fetch(window.Shopify.routes.root + '?sections=cl-cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        swapDrawer(data['cl-cart-drawer']);
        if (open) openDrawer('cart');
        return syncCount();
      });
  }

  /* Jubileumactie: een gratis bag charm hoort bij een tas. Haalt iemand een tas
     weg, dan gaat de cadeau-charm mee. Cadeau-charms zijn herkenbaar aan het
     verborgen kenmerk _ae_gift; een charm die iemand los koopt heeft dat niet
     en blijft dus gewoon staan. */
  var onCartPage = function () { return !!$('.cl-cartp'); };
  var tidying = false;
  function aeTidy(cart) {
    if (tidying || !cart || !cart.items) return Promise.resolve(false);
    /* Het cadeau is ook herkenbaar aan het cadeauproduct zelf (window.CMFY_GIFT,
       gezet door de winkelwagenlade). Na de actie (live: false) mag er geen
       enkel cadeau meer in de winkelwagen staan. */
    var G = window.CMFY_GIFT || {};
    var bags = 0, gifts = [], goods = 0, svc = [];
    cart.items.forEach(function (it) {
      if (isSvc(it)) { svc.push(it); return; }
      goods += it.quantity;
      if ((it.properties && it.properties._ae_gift) || (G.product && it.product_id === G.product)) { gifts.push(it); return; }
      if (it.vendor === 'CMFY BAGS' && it.product_type !== 'Tassenhanger') bags += it.quantity;
    });
    var allowed = G.live === false ? 0 : bags;
    var extra = gifts.reduce(function (sum, it) { return sum + it.quantity; }, 0) - allowed;
    var updates = {}, changes = 0;
    for (var i = gifts.length - 1; i >= 0 && extra > 0; i--) {
      var take = Math.min(extra, gifts[i].quantity);
      updates[gifts[i].key] = gifts[i].quantity - take;
      extra -= take; changes++;
    }
    /* Extra beveiligd verzenden hoort bij een bestelling met producten, en hooguit één keer:
       zonder producten gaat het eruit, een hoger aantal wordt 1. */
    svc.forEach(function (it) {
      var want = goods > 0 ? 1 : 0;
      if (it.quantity !== want) { updates[it.key] = want; changes++; }
    });
    if (!changes) return Promise.resolve(false);
    tidying = true;
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () { tidying = false; return true; }, function () { tidying = false; return false; });
  }

  /* Op de losse winkelwagenpagina bestaat geen lade om te verversen: na een
     wijziging ruimen we op en laden we de pagina opnieuw. */
  function afterCartPageChange() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(aeTidy)
      .then(function () { window.location.reload(); }, function () { window.location.reload(); });
  }

  /* Ook bij het laden van een pagina: een winkelwagen die nog een losse
     cadeau-charm bevat (bijvoorbeeld van een eerder bezoek) wordt rechtgezet. */
  (function () {
    var count = $('[data-cl-cart-count]');
    if (!count || !(Number(count.getAttribute('data-cl-cart-raw') || count.textContent) > 0)) return;
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(aeTidy)
      .then(function (changed) {
        if (!changed) return;
        if (onCartPage()) window.location.reload(); else refreshCart(false);
      })
      .catch(function () {});
  })();

  function clonePayMarks() {
    var src = $('#clPayMarks');
    var dest = $('[data-cl-paymarks]');
    if (src && dest && !dest.childElementCount) dest.innerHTML = src.innerHTML;
  }
  clonePayMarks();

  /* Snel afrekenen (Apple Pay, Google Pay …) in de winkelwagenlade. Shopify levert
     die knoppen alleen bij een volledige paginalading (#clExpressSrc in de layout).
     We verplaatsen ze naar de lade en zetten ze terug vóórdat de lade ververst
     wordt, zodat ze niet verdwijnen. */
  function placeExpress() {
    var src = $('#clExpressSrc');
    var dest = $('[data-cl-express]');
    if (!src || !dest || dest.childElementCount) return;
    while (src.firstChild) dest.appendChild(src.firstChild);
  }
  function parkExpress(drawer) {
    var src = $('#clExpressSrc');
    var box = drawer && drawer.querySelector('[data-cl-express]');
    if (!src || !box) return;
    while (box.firstChild) src.appendChild(box.firstChild);
  }
  placeExpress();

  /* Artikel uit een formulier, inclusief eventuele verborgen kenmerken
     (properties[...]), zoals het cadeau-label van de gratis bag charm. */
  function addItem(form) {
    var item = {
      id: Number(form.querySelector('[name="id"]').value),
      quantity: Number((form.querySelector('[name="quantity"]') || {}).value || 1)
    };
    var props = {};
    $$('[name^="properties["]', form).forEach(function (inp) {
      if (inp.value) props[inp.name.slice(11, -1)] = inp.value;
    });
    if (Object.keys(props).length) item.properties = props;
    return item;
  }

  /* Direct zichtbaar resultaat (gebruiker 11-10: 'winkelwagen dubbel, lijkt of er iets achter zit' en 'sneller laden'):
     het gekozen product staat meteen in de lade, bovenaan zoals Shopify het ook zet, in plaats van de oude inhoud
     half doorzichtig. Het antwoord van Shopify (echte bedragen en korting) vervangt de lade daarna ongemerkt. */
  var escH = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  };
  var sizeLike = function (o) { return /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL|\d{2})$/i.test(o); };
  // bedrag 'x' keer, in dezelfde notatie als Shopify ('1.100,00 zł')
  var timesMoney = function (txt, qty) {
    var cents = Number(String(txt).replace(/[^\d]/g, '')) * qty;
    var a = (cents / 100).toFixed(2).split('.');
    a[0] = a[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return String(txt).replace(/\d[\d.\s]*,\d{2}/, a[0] + ',' + a[1]);
  };
  var plWord = function (n) {
    var t = n % 10, h = n % 100;
    if (n === 1) return 'produkt';
    if (t >= 2 && t <= 4 && (h < 12 || h > 14)) return 'produkty';
    return 'produktów';
  };
  var setHeadCount = function (drawer, n) {
    var title = drawer.querySelector('.wb-cart__title');
    if (!title) return;
    var c = title.querySelector('.wb-cart__count');
    if (!c) { c = document.createElement('span'); c.className = 'wb-cart__count'; title.appendChild(document.createTextNode(' ')); title.appendChild(c); }
    c.textContent = n + ' ' + plWord(n);
  };
  function previewAdd(form) {
    var pdp = form.closest('[data-wb-pdp]');
    var drawer = $('[data-cl-drawer="cart"]');
    var data = pdp && pdp.querySelector('[data-wb-variants]');
    if (!drawer || !data) return;
    var id = Number((form.querySelector('[name="id"]') || {}).value);
    var qty = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
    var v = null;
    try { v = JSON.parse(data.textContent).filter(function (x) { return x.id === id; })[0]; } catch (err) { v = null; }
    if (!v) return;
    // aantal in de kop meteen bijwerken
    var countNow = 0;
    $$('.wb-line__n', drawer).forEach(function (x) { countNow += Number(x.textContent) || 0; });
    setHeadCount(drawer, countNow + qty);
    // zelfde variant ligt er al: alleen het aantal ophogen
    var same = drawer.querySelector('.wb-line[data-variant="' + id + '"]');
    if (same) {
      var n = same.querySelector('.wb-line__n');
      if (n) n.textContent = Number(n.textContent) + qty;
      return;
    }
    var titleEl = pdp.querySelector('.wb-pdp__title');
    // zelfde opmaak als de lade: "Kolor: Brązowy, Rozmiar: XS" (gebruiker 27-10)
    var optNames = [];
    $$('fieldset[data-wb-opt]', pdp).forEach(function (f) {
      var l = f.querySelector('.wb-opt__label span');
      if (l && l.firstChild) optNames[Number(f.getAttribute('data-wb-opt'))] = String(l.firstChild.textContent).replace(/:\s*$/, '').trim();
    });
    var opts = (v.options || []).map(function (o, i) { return (o && o !== 'Default Title') ? (optNames[i] ? optNames[i] + ': ' : '') + o : ''; })
      .filter(Boolean).join(', ');
    var img = v.img ? String(v.img).replace('width=120', 'width=300') : '';
    var trashTpl = drawer.querySelector('template[data-wb-trash]');
    // besparing zoals de echte regel: (van-prijs − prijs) × aantal
    var saveTxt = '';
    if (v.compare) {
      var cDiff = Number(String(v.compare).replace(/[^\d]/g, '')) - Number(String(v.price).replace(/[^\d]/g, ''));
      if (cDiff > 0) saveTxt = timesMoney(String(v.price).replace(/\d[\d.\s]*,\d{2}/, (cDiff / 100).toFixed(2).replace('.', ',')), qty);
    }
    var li = document.createElement('li');
    li.className = 'wb-line is-pending';
    li.setAttribute('data-variant', id);
    li.innerHTML = '<span class="wb-line__img">' + (img ? '<img src="' + escH(img) + '" alt="">' : '') + '</span>' +
      '<div class="wb-line__body"><div class="wb-line__top"><span class="wb-line__title">' + escH(titleEl ? titleEl.textContent.trim() : '') + '</span>' +
      '<span class="wb-line__remove" aria-hidden="true">' + (trashTpl ? trashTpl.innerHTML : '') + '</span></div>' +
      (opts ? '<p class="wb-line__variant">' + escH(opts) + '</p>' : '') +
      '<div class="wb-line__bottom"><div class="wb-line__qty"><span class="wb-line__step">−</span><span class="wb-line__n">' + qty + '</span><span class="wb-line__step">+</span></div>' +
      '<div class="wb-line__prices"><p class="wb-line__price">' + (v.compare ? '<s>' + escH(timesMoney(v.compare, qty)) + '</s> ' : '') +
      '<span>' + escH(timesMoney(v.price, qty)) + '</span></p>' +
      (saveTxt ? '<p class="wb-line__save">Oszczędzasz <span>' + escH(saveTxt) + '</span></p>' : '') + '</div></div></div>';
    var list = drawer.querySelector('.wb-cart__items');
    if (list) {
      list.insertBefore(li, list.firstChild);
      var sc = drawer.querySelector('.wb-cart__scroll');
      if (sc) sc.scrollTop = 0;
      return;
    }
    // lege winkelwagen: het raamwerk uit de lade (template data-wb-skel) invullen, zodat meteen de hele
    // winkelwagen staat zoals Shopify hem straks teruggeeft (verzendregel, kortingskaart, totaal, knop)
    var empty = drawer.querySelector('.wb-cart__empty');
    if (!empty) return;
    var skel = drawer.querySelector('template[data-wb-skel]');
    if (skel && skel.content) {
      var frag = skel.content.cloneNode(true);
      var sl = frag.querySelector('.wb-cart__items');
      if (sl) sl.appendChild(li);
      var tot = frag.querySelector('[data-wb-skel-total]');
      if (tot) tot.textContent = timesMoney(v.price, qty);
      empty.parentNode.insertBefore(frag, empty);
      empty.parentNode.removeChild(empty);
      if (typeof dispatchTick === 'function') dispatchTick();
      return;
    }
    var box = document.createElement('div');
    box.className = 'wb-cart__scroll wb-cart__scroll--pending';
    box.innerHTML = '<ul class="wb-cart__items"></ul>';
    box.firstChild.appendChild(li);
    empty.parentNode.insertBefore(box, empty);
  }

  /* Rustig verloop na 'Dodaj do koszyka' (gebruiker 19-10: 'mooi verloop van productpagina naar winkelwagen en
     dat alles in de winkelwagen geladen is, dat komt strakker over'). De lade wordt eerst achter de schermen gevuld
     en de foto's van de regels en de eerste aanbevelingen laden; pas dan schuift hij open, met de inhoud rustig na
     elkaar in beeld en het zojuist gekozen product even licht gemarkeerd. Duurt een foto langer dan 0,9 s, dan
     opent de lade toch (die foto komt dan zacht in beeld via waitFade). De directe voorvertoning hierboven
     (previewAdd) wordt daarom niet meer aangeroepen; hij blijft staan voor als die terug moet. */
  function drawerReady(d, max) {
    var imgs = $$('.wb-line__img img', d).concat($$('.wb-up__img img', d).slice(0, 2));
    var waits = imgs.map(function (im) {
      im.loading = 'eager';
      var dec = function () { return im.decode ? im.decode().catch(function () {}) : null; };
      if (im.complete) return im.naturalWidth ? dec() : null;
      return new Promise(function (res) {
        im.addEventListener('load', function () { Promise.resolve(dec()).then(res); }, { once: true });
        im.addEventListener('error', res, { once: true });
      });
    });
    return Promise.race([
      Promise.all(waits),
      new Promise(function (res) { window.setTimeout(res, max || 900); })
    ]);
  }

  /* Foto van de gekozen variant alvast ophalen terwijl Shopify het product toevoegt, in de maat die de regel in
     de lade kiest (sizes 110px: 150w, op scherpe schermen 300w). Dan hoeft de lade daar niet meer op te wachten. */
  function warmLine(form) {
    var pdp = form.closest('[data-wb-pdp]');
    var data = pdp && pdp.querySelector('[data-wb-variants]');
    if (!data) return;
    var id = Number((form.querySelector('[name="id"]') || {}).value);
    var v = JSON.parse(data.textContent).filter(function (x) { return x.id === id; })[0];
    if (!v || !v.img) return;
    var w = (window.devicePixelRatio || 1) * 110 <= 150 ? 150 : 300;
    new Image().src = String(v.img).replace('width=120', 'width=' + w);
  }

  function arrive(variantId) {
    var d = $('[data-cl-drawer="cart"]');
    if (!d) return Promise.resolve();
    return drawerReady(d, 900).then(function () {
      d = $('[data-cl-drawer="cart"]');
      if (!d) return;
      var line = d.querySelector('.wb-line[data-variant="' + variantId + '"]');
      if (line) line.classList.add('is-new');
      if (d.classList.contains('is-open')) return;
      d.classList.add('is-arriving');
      window.setTimeout(function () { d.classList.remove('is-arriving'); }, 1600);
      openDrawer('cart');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-cl-add-form]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    var cartPage = onCartPage();
    var drawerNow = $('[data-cl-drawer="cart"]');
    var inDrawer = !!(drawerNow && drawerNow.classList.contains('is-open'));
    /* De knop laat zien dat het bezig is (zelfde breedte en kleur, draaiend rondje); de lade opent pas als hij
       gevuld is, zie arrive(). De vaste koopbalk onderaan krijgt hetzelfde rondje als hij dit formulier gebruikt. */
    if (btn) {
      btn.style.minWidth = btn.offsetWidth + 'px';
      btn.disabled = true; btn.classList.add('is-adding'); btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Dodawanie…';
    }
    var stickyBtn = form.querySelector('[data-wb-add]') ? $('[data-wb-sticky-btn]') : null;
    if (stickyBtn) stickyBtn.classList.add('is-adding');
    var reset = function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-adding', 'is-added'); btn.removeAttribute('aria-busy'); btn.textContent = label; btn.style.minWidth = ''; }
      if (stickyBtn) stickyBtn.classList.remove('is-adding');
    };
    if (!cartPage && !inDrawer) { try { warmLine(form); } catch (err) { /* alleen gemak */ } }
    /* Toevoegen vanuit de open lade (aanbevelingen): de lade blijft open met het laadbalkje. */
    if (!cartPage && inDrawer) {
      drawerNow.classList.add('is-loading');
      /* Veiligheid: hangt het laden ooit, dan blijft de lade na 6 s toch bedienbaar. */
      window.setTimeout(function () { var dl = $('[data-cl-drawer="cart"]'); if (dl) dl.classList.remove('is-loading'); }, 6000);
    }

    /* Jubileumactie: staat er een gekozen gratis bag charm in het formulier
       (data-cl-gift), dan gaat die in dezelfde stap mee. Lukt dat niet, dan
       wordt de tas alsnog los toegevoegd; de charm is dan in de winkelwagen
       te kiezen. */
    var items = [addItem(form)];
    var giftEl = form.querySelector('[data-cl-gift]');
    if (giftEl && giftEl.value) items.push({ id: Number(giftEl.value), quantity: 1, properties: { _ae_gift: '1' } });
    var post = function (list) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: list, sections: 'cl-cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) throw new Error(res.description || res.message);
          return res;
        });
    };

    var added = false;
    post(items)
      .catch(function (err) { if (items.length > 1) return post([items[0]]); throw err; })
      .then(function (res) {
        if (cartPage) return afterCartPageChange();
        added = true;
        var swapped = swapDrawer(res && res.sections && res.sections['cl-cart-drawer']);
        return (swapped ? Promise.resolve() : refreshCart(false))
          .then(function () {
            if (btn) { btn.classList.remove('is-adding'); btn.classList.add('is-added'); btn.textContent = 'Dodano'; }
            return arrive(items[0].id);
          })
          .then(function () { if (swapped) return syncCount(); });
      })
      .catch(function (err) {
        var open = $('[data-cl-drawer="cart"]');
        // het product zit er wel in, alleen het bijwerken haperde: lade toch tonen
        if (added) { if (open && !open.classList.contains('is-open')) openDrawer('cart'); return; }
        if (open && !cartPage) open.classList.remove('is-loading');
        if (!cartPage) refreshCart(false).catch(function () {});
        var note = form.querySelector('[data-cl-add-error]');
        if (note) { note.textContent = err.message || 'Nie udało się dodać produktu.'; note.hidden = false; }
      })
      .then(function () {
        // de knop gaat terug zodra de lade erover ligt; bij een fout meteen
        window.setTimeout(reset, added ? 700 : 0);
      });
  });

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cl-qty]');
    if (!q) return;
    e.preventDefault();
    var cartPageQ = onCartPage();
    var drawerQ = $('[data-cl-drawer="cart"]');
    if (!cartPageQ && drawerQ) {
      drawerQ.classList.add('is-loading');
      // aantal meteen tonen; bij verwijderen wordt de regel direct lichter (de echte lade volgt zo)
      var qLine = q.closest('.wb-line');
      var qTo = Number(q.getAttribute('data-cl-to'));
      if (qLine) {
        if (qTo === 0) qLine.classList.add('is-removing');
        else { var qN = qLine.querySelector('.wb-line__n'); if (qN) qN.textContent = qTo; }
      }
    }
    window.setTimeout(function () { var dq = $('[data-cl-drawer="cart"]'); if (dq) dq.classList.remove('is-loading'); }, 6000);
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(q.getAttribute('data-cl-qty')), quantity: Number(q.getAttribute('data-cl-to')), sections: 'cl-cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartPageQ) return afterCartPageChange();
        if (cart && cart.sections && swapDrawer(cart.sections['cl-cart-drawer'])) {
          setCount(goodsCount(cart), cart.item_count);
          return aeTidy(cart).then(function (changed) { if (changed) return refreshCart(false); });
        }
        return refreshCart(false);
      })
      .catch(function () {
        if (cartPageQ) { window.location.reload(); return; }
        var d = $('[data-cl-drawer="cart"]'); if (d) d.classList.remove('is-loading');
        return refreshCart(false);
      });
  });

  /* Extra beveiligd verzenden (vinkje boven 'Razem' in de lade en op de winkelwagenpagina): de dienst gaat
     als los product in de winkelwagen of eruit. De klant kiest dit zelf; het staat nooit vooraf aan. */
  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest ? e.target.closest('[data-wb-ins]') : null;
    if (!box) return;
    var on = box.checked, id = Number(box.getAttribute('data-wb-ins'));
    var row = box.closest('.wb-ins');
    var onPage = !!box.closest('.wb-cartpage') || onCartPage();
    if (row) row.classList.toggle('is-on', on);
    box.disabled = true;
    var drawerI = $('[data-cl-drawer="cart"]');
    if (!onPage && drawerI) drawerI.classList.add('is-loading');
    var body = on ? { items: [{ id: id, quantity: 1 }] } : { id: String(id), quantity: 0 };
    if (!onPage) { body.sections = 'cl-cart-drawer'; body.sections_url = window.location.pathname; }
    fetch(window.Shopify.routes.root + (on ? 'cart/add.js' : 'cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status !== 200) throw new Error(res.description || res.message || 'ins');
        if (onPage) { window.location.reload(); return; }
        if (swapDrawer(res && res.sections && res.sections['cl-cart-drawer'])) return;
        return refreshCart(false);
      })
      .catch(function () {
        box.checked = !on; box.disabled = false;
        if (row) row.classList.toggle('is-on', !on);
        var d = $('[data-cl-drawer="cart"]'); if (d) d.classList.remove('is-loading');
      });
  });

  /* ------------------------------------------------------ announcement -- */

  // Elke 5 seconden de volgende tekst: de oude krijgt is-out (schuift weg), de nieuwe is-on (komt in beeld).
  // Stopt zolang het tabblad verborgen is, zodat er bij terugkomen geen wissels achter elkaar komen.
  var annItems = $$('[data-cl-ann]');
  if (annItems.length > 1) {
    var ai = 0, annTimer = null;
    var annNext = function () {
      var prev = annItems[ai];
      ai = (ai + 1) % annItems.length;
      annItems.forEach(function (el) { if (el !== prev) el.classList.remove('is-out'); });
      prev.classList.remove('is-on');
      prev.classList.add('is-out');
      annItems[ai].classList.add('is-on');
    };
    var annStart = function () { if (!annTimer) annTimer = window.setInterval(annNext, 5000); };
    var annStop = function () { window.clearInterval(annTimer); annTimer = null; };
    document.addEventListener('visibilitychange', function () { if (document.hidden) annStop(); else annStart(); });
    if (!document.hidden) annStart();
  }

  /* ---------------------------------------------------------- countdown -- */

  var cd = $('[data-cl-countdown]');
  if (cd) {
    // Parsed as UK local time. If the date is unreadable or already past,
    // the block simply stays hidden — it never falls back to a fake number.
    var raw = (cd.getAttribute('data-cl-countdown') || '').trim().replace(' ', 'T');
    var target = Date.parse(raw.length === 16 ? raw + ':00' : raw);
    if (!isNaN(target)) {
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var parts = {
        d: cd.querySelector('[data-cl-cd="d"]'),
        h: cd.querySelector('[data-cl-cd="h"]'),
        m: cd.querySelector('[data-cl-cd="m"]'),
        s: cd.querySelector('[data-cl-cd="s"]')
      };
      var tick = function () {
        var left = target - Date.now();
        if (left <= 0) { cd.hidden = true; window.clearInterval(timer); return; }
        var sec = Math.floor(left / 1000);
        if (parts.d) parts.d.textContent = pad(Math.floor(sec / 86400));
        if (parts.h) parts.h.textContent = pad(Math.floor(sec / 3600) % 24);
        if (parts.m) parts.m.textContent = pad(Math.floor(sec / 60) % 60);
        if (parts.s) parts.s.textContent = pad(sec % 60);
        cd.hidden = false;
      };
      tick();
      var timer = window.setInterval(tick, 1000);
    }
  }

  /* --------------------------------------------------------- hero video -- */

  var heroVideo = $('[data-cl-hero-video]');
  if (heroVideo) {
    var wantsMotion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (wantsMotion && !saveData) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var src = heroVideo.getAttribute(isMobile ? 'data-src-mobile' : 'data-src-desktop');
      if (src) {
        var start = function () {
          heroVideo.src = src;
          heroVideo.load();
          heroVideo.play().catch(function () {});
        };
        if ('requestIdleCallback' in window) { window.requestIdleCallback(start, { timeout: 1500 }); }
        else { window.setTimeout(start, 300); }
      }
    }
  }

  /* ------------------------------------------------------------ reveals -- */

  /* Everything is shown as soon as the page paints. Revealing blocks on scroll
     made the page read as half-loaded on a phone, where most of it starts
     below the fold. */
  $$('.cl-reveal').forEach(function (el) { el.classList.add('is-in'); });

  /* -------------------------------------------------------- pdp gallery -- */

  $$('[data-cl-gallery]').forEach(function (gal) {
    var stage = $('[data-cl-stage]', gal);
    var thumbs = $$('[data-cl-thumb]', gal);
    if (!stage) return;

    var idx = 0;

    function show(index, fromUser) {
      var slides = $$('[data-cl-slide]', stage);
      if (index < 0) { index = 0; }
      if (index > slides.length - 1) { index = slides.length - 1; }
      idx = index;
      slides.forEach(function (s, i) {
        var on = i === index;
        s.hidden = !on;
        var v = s.querySelector('video');
        if (v) {
          if (on) {
            /* The slide markup ships preload="none" so a gallery of videos costs
               nothing on load; the visible one has to be told to fetch itself
               before play() has anything to start. */
            v.muted = true;
            v.playsInline = true;
            v.setAttribute('playsinline', '');
            if (v.preload === 'none' || v.readyState === 0) { v.preload = 'auto'; v.load(); }
            var pr = v.play();
            if (pr && pr.catch) { pr.catch(function () {}); }
          } else { v.pause(); }
        }
      });
      thumbs.forEach(function (t, i) {
        var on = i === index;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        /* Keep the strip in step with the stage, but only once someone has
           actually interacted: calling this during the initial show(0) can
           yank the page about before the visitor has touched anything. */
        if (on && fromUser && t.scrollIntoView) {
          try { t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); }
          catch (e) { t.scrollIntoView(); }
        }
      });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i, true); }); });

    /* Open on the clip when the product has one. The markup already puts
       videos before the photographs, so this is normally slide 0; the search
       keeps it right for any product whose media are ordered differently. */
    var opening = 0;
    var startSlides = $$('[data-cl-slide]', stage);
    for (var oi = 0; oi < startSlides.length; oi++) {
      if (startSlides[oi].querySelector('video, iframe')) { opening = oi; break; }
    }
    show(opening);

    /* Swipe left/right on a phone. The stage swaps slides outright rather than
       sliding, so the gesture only has to be read, not followed. The listeners
       stay passive and never preventDefault, so scrolling the page down through
       the gallery keeps working; a swipe only counts when it is clearly
       sideways and long enough not to be a stray thumb movement. */
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) { tracking = false; return; }
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (Math.abs(dx) < 40) return;
      if (Math.abs(dx) < Math.abs(dy) * 1.5) return;
      show(dx < 0 ? idx + 1 : idx - 1, true);
    }, { passive: true });
    stage.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
  });

  /* -------------------------------------------------------- pdp variant -- */

  $$('[data-cl-product]').forEach(function (root) {
    var dataEl = $('[data-cl-variants]', root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('[name="id"]', root);
    var priceEl = $('[data-cl-price]', root);
    var btn = $('[data-cl-add]', root);
    var selects = $$('[data-cl-option]', root);

    function current() {
      var chosen = selects.map(function (s) { return s.value; });
      return variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }

    function apply(fromUser) {
      var v = current();
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Niedostępne'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span class="cl-price' + (v.compare_at_price > v.price ? ' cl-price--sale' : '') + '">' + money(v.price) + '</span>';
        if (v.compare_at_price > v.price) html += '<span class="cl-price__was">' + money(v.compare_at_price) + '</span>';
        priceEl.innerHTML = html;
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (btn.getAttribute('data-cl-label') || 'Dodaj do koszyka') : 'Wyprzedane';
      }
      /* Follow the variant's own photo only when the visitor actually chose a
         colour. On the first load the gallery keeps whatever it opened on, so
         a product with a video opens on the video rather than being dragged
         straight to the default colour's still. */
      if (fromUser && v.featured_media_index != null) {
        var allThumbs = $$('[data-cl-thumb]', root);
        var lead = 0;
        allThumbs.forEach(function (t) { if (!t.hasAttribute('data-cl-media-pos')) { lead++; } });
        var wantPos = String(v.featured_media_index - lead + 1);
        var thumb = null;
        allThumbs.forEach(function (t) {
          if (!thumb && t.getAttribute('data-cl-media-pos') === wantPos) { thumb = t; }
        });
        if (!thumb) { thumb = allThumbs[v.featured_media_index]; }
        if (thumb) thumb.click();
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', function () { apply(true); }); });
    apply(false);
  });

  /* ------------------------------------------------ option pills + qty -- */

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-cl-pill]');
    if (pill) {
      var group = pill.closest('[data-cl-optgroup]');
      var sel = group.querySelector('[data-cl-option]');
      $$('[data-cl-pill]', group).forEach(function (p) { p.classList.toggle('is-on', p === pill); });
      sel.value = pill.getAttribute('data-cl-pill');
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var step = e.target.closest('[data-cl-step]');
    if (step) {
      var input = step.parentNode.querySelector('input[name="quantity"]');
      if (!input) return;
      var next = Number(input.value || 1) + Number(step.getAttribute('data-cl-step'));
      input.value = Math.max(1, next);
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cl-option]')) return;
    var group = e.target.closest('[data-cl-optgroup]');
    var label = group ? group.querySelector('[data-cl-optvalue]') : null;
    if (label) label.textContent = e.target.value;
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cl-scroll-top]')) return;
    e.preventDefault();
    var anchor = $('[data-cl-atc-anchor]');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ------------------------------------------------------ recommendations */

  var recs = $('[data-cl-recs]');
  if (recs && recs.getAttribute('data-url')) {
    fetch(recs.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-cl-recs-inner]');
        if (inner) recs.innerHTML = inner.outerHTML;
      })
      .catch(function () {});
  }

  /* ----------------------------------------------- judge.me review pics -- */

  /* The review widget ships its photos as data-src and leaves them to its own
     lazy loader, which never fires inside this theme: every photo sits on a
     spinner for ever. Swapping the attribute ourselves is all it needs. */
  var loadReviewPics = function () {
    $$('.jdgm-rev__pic-img[data-src]').forEach(function (img) {
      if (img.getAttribute('src')) return;
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      var link = img.closest('.jdgm-rev__pic-link');
      if (link) link.classList.remove('jdgm--loading');
    });
  };
  loadReviewPics();
  if ('MutationObserver' in window) {
    var picTimer = null;
    new MutationObserver(function () {
      window.clearTimeout(picTimer);
      picTimer = window.setTimeout(loadReviewPics, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------------- dispatch clock -- */

  /* Een echte deadline met een echt gevolg: het pakket gaat vandaag de deur uit
     of morgen. Het beweert niets over voorraad, reserveert niets en neemt niets
     weg als de tijd om is — het verandert alleen wat er staat. De tijden worden
     in Europe/Amsterdam gelezen, zodat het getal klopt voor een Nederlandse
     klant waar ter wereld die ook zit te kijken, en het blok blijft verborgen
     tot er een echte waarde te tonen is. */

  var ukNow = function () {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', hour12: false,
      weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      day: o.weekday,
      seconds: (Number(o.hour) % 24) * 3600 + Number(o.minute) * 60 + Number(o.second)
    };
  };

  var DAY_ORDER = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAY_FULL = {
    Sun: 'w niedzielę', Mon: 'w poniedziałek', Tue: 'we wtorek', Wed: 'w środę',
    Thu: 'w czwartek', Fri: 'w piątek', Sat: 'w sobotę'
  };

  var dispatchTick = function () {
    var nodes = $$('[data-cl-dispatch]');
    if (!nodes.length) return;

    var now;
    try { now = ukNow(); } catch (e) { return; }

    nodes.forEach(function (el) {
      var msg = el.querySelector('[data-cl-dispatch-msg]');
      if (!msg) return;

      var raw = (el.getAttribute('data-cutoff') || '20:00').split(':');
      var cut = (Number(raw[0]) || 0) * 3600 + (Number(raw[1]) || 0) * 60;
      if (!cut) { el.hidden = true; return; }

      var weekdaysOnly = el.getAttribute('data-days') === 'weekdays';
      var idx = DAY_ORDER.indexOf(now.day);
      var isDispatchDay = function (i) {
        if (!weekdaysOnly) return true;
        return i !== 0 && i !== 6;
      };

      var left = cut - now.seconds;

      if (isDispatchDay(idx) && left > 0) {
        var h = Math.floor(left / 3600);
        var m = Math.floor((left % 3600) / 60);
        var when;
        if (h > 0) { when = h + ' godz. ' + m + ' min'; }
        else if (m > 0) { when = m + ' min'; }
        else { when = 'minuty'; }
        msg.innerHTML = 'Zamów w ciągu <b>' + when + '</b>, a wyślemy dziś';
      } else {
        /* Winkelwagen: na de besteltijd geen 'wyślemy jutro' (gebruiker 12-10), dan verdwijnt de balk. */
        if (el.hasAttribute('data-today-only')) { el.hidden = true; return; }
        var next = idx;
        var hops = 0;
        do { next = (next + 1) % 7; hops++; } while (!isDispatchDay(next) && hops < 8);
        var label = hops === 1 ? 'jutro' : (DAY_FULL[DAY_ORDER[next]] || 'w najbliższy dzień roboczy');
        msg.innerHTML = 'Zamów teraz – wyślemy <b>' + label + '</b>';
      }
      el.hidden = false;
    });
  };

  if (window.Intl && Intl.DateTimeFormat) {
    dispatchTick();
    window.setInterval(dispatchTick, 1000);
  }


  /* ----------------------------------------------------- sticky add bar -- */

  var stickyBar = $('[data-cl-sticky]');
  var anchor = $('[data-cl-atc-anchor]');
  if (stickyBar && anchor) {
    /* Plain scroll position rather than an IntersectionObserver: the observer
       only reports crossings, so a jump-scroll or a late layout shift could
       leave the bar hidden with the real button far off-screen. */
    var syncSticky = function () {
      stickyBar.classList.toggle('is-on', anchor.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);
    syncSticky();
    stickyBar.addEventListener('click', function (e) {
      if (e.target.closest('[data-cl-sticky-add]')) {
        e.preventDefault();
        var form = $('[data-cl-add-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  /* ------------------------------------------------- einde jubileumactie -- */
  /* Actieblokken dragen data-cmfy-end="JJJJMMDD" (laatste dag, Nederlandse tijd).
     De server verbergt ze al na die dag; dit vangt een pagina op die nog uit een
     cache komt, zodat er nooit een actie zichtbaar blijft die niet meer geldt. */
  (function () {
    var nodes = $$('[data-cmfy-end]');
    if (!nodes.length) return;
    var now = Date.now();
    nodes.forEach(function (n) {
      var d = n.getAttribute('data-cmfy-end') || '';
      if (!/^[0-9]{8}$/.test(d)) return;
      var end = Date.parse(d.slice(0, 4) + '-' + d.slice(4, 6) + '-' + d.slice(6, 8) + 'T23:59:59+02:00');
      if (end && now > end) n.hidden = true;
    });
  })();
})();
